import Cookies from "universal-cookie";

const cookies = new Cookies();

export function setToken(token) {
  cookies.set("access_token", token, { path: "/", maxAge: 60 * 60 * 24 });
}

export function getToken() {
  return cookies.get("access_token");
}

export function clearToken() {
  cookies.remove("access_token", { path: "/" });
}

export function getRefreshToken() {
  return cookies.get("refresh_token");
}

export function setRefreshToken(refreshToken) {
  cookies.set("refresh_token", refreshToken, {
    path: "/",
    maxAge: 60 * 60 * 24,
  });
}

export function clearRefreshToken() {
  cookies.remove("refresh_token", { path: "/" });
}

export function clearAllTokens() {
  clearToken();
  clearRefreshToken();
}
